import { createAction } from "redux-actions";

export const getCurrencies = createAction("GET_CURRENCIES");
export const getCurrenciesSuccess = createAction("GET_CURRENCIES_SUCCESS");
export const getCurrenciesError = createAction("GET_CURRENCIES_ERROR");
export const setCurrenciesStatus = createAction("SET_CURRENCIES_STATUS");
export const setCurrenciesLoaded = createAction("SET_CURRENCIES_LOADED");
export const setCurrenciesLoading = createAction("SET_CURRENCIES_LOADING");
